module.exports = __webpack_public_path__ + "static/Icons_USDA_inactive-91632968e42d2f3d0b6c3b1bd6857dae.png";